module.exports = __webpack_public_path__ + "assets/1c54ea905e75c9daaa441354acb6d130.png";